// ----------------------------------------------------------------------------
// Component: Ticker Bar
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

import './_ticker-bar.scss';